export function initShare({
    callback
} = {}) {

    if (_.urlInfo.sys === 'ijijin') {
        window.customClick = () => {
            callback && callback();
        }
        callNativeHandler('customWebNavigationBar', {
            "title": {
                "text": "指数估值",
            },
            "rightButton": [
                {
                    "text": "",
                    "textColor": "0x999999",
                    "imageUrl": "https://so.thsi.cn/cd/ijj-thsi-cn/zy/indexValuation/share.png",
                    "onClick": "window.customClick()"
                }
            ]
        })
    }  else if (_.urlInfo.sys === 'ths') {
        callNativeHandler('notifyWebHandleEvent', {
            'method': 'setTitleBar',
            'params': {
                'rightViewType': 'ShareImageView', //右上角功能的类型
                'stopSetNil': 'yes' //显示右上角按钮
            }
        });
        callNativeHandler(
            'changeWebViewButton'
        );
        registerWebHandler('changeWebViewButton', function (data) {
            if (data.clickButton && data.clickButton === 'native_share') {
                callback && callback();
            }
        });
    }
}

export function startShare(imgUrl, type, title, description) {
    if (_.urlInfo.sys === 'ijijin') {
        console.log(type, title, description)
        let _shareData = {
            title,
            description,
            shareUrl: "https://testfund.10jqka.com.cn",
            image: imgUrl,
            shareType: "2",
            sharePlace: type,
            flag: "分享",
        };
        callNativeHandler(
            "WebShare",
            {..._shareData},
            function(data) {
                console.log(data);
                let timer = setTimeout(() => {
                    clearTimeout(timer);
                    location.reload();
                }, 300)
            }
          );
    }  else if (_.urlInfo.sys === 'ths') {
        let _shareData = {
            type: '2',
            title,
            content: description,
            bmpRes: '1',
            bmpUrl: imgUrl,
            actionKey: '1',
            platforms:['qq','qqzone','weixin','friends','weibo']
        };

        callNativeHandler('hexinShare', JSON.stringify(_shareData), function() { });
    }
    
}
/**
 * 改变标题栏颜色
 * @param color 16进制颜色
 *
 */
export const changeTitleBar = (color) => {
    // 标题栏颜色
    if (_.urlInfo.sys === 'ths') {
      callNativeHandler(
        'changeWebViewTitleColor',
        {
          data: {
            status: 'change',
            color: color,
          },
        },
        () => ''
      );
    }
};

export function oldStartShare({ 
    title = '', 
    shareUrl = '', 
    description = '', 
    type
} = {}) {
    if (!shareUrl) return false;
    if (_.urlInfo.sys === 'ijijin') {
        let _shareData = {
            title,
            description,
            shareUrl,
            sharePlace: type,
            flag: "0",
        };
        callNativeHandler('WebShare', 
            { ..._shareData }, 
            function () {}
        );
    }  else if (_.urlInfo.sys === 'ths') {

        callNativeHandler('hexinShare', JSON.stringify({
            type: '1',
            url: shareUrl,
            content: description,
            title,
            actionKey: '1',
            platforms:['qq','qqzone','weixin','friends','weibo']
        }), function () {
        });
    }
    
}

export function debounce(fn, delay = 500){
    // 维护一个 timer
    let timer = null;
    
    return function(...args) {
        // 获取函数的作用域和变量
        let context = this;
        if (timer) {
            clearTimeout(timer);
        }
        timer = setTimeout(function(){
            fn.apply(context, args);
        }, delay)
    }
}
